import { render, staticRenderFns } from "./CodeVerify.vue?vue&type=template&id=a5b0cd30"
import script from "./CodeVerify.vue?vue&type=script&lang=js"
export * from "./CodeVerify.vue?vue&type=script&lang=js"
import style0 from "./CodeVerify.vue?vue&type=style&index=0&id=a5b0cd30&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports